import React, { useState, useEffect } from "react";
import { ScrollView } from "react-native";
import { useTheme } from "react-native-paper";

import { useDispatch, useSelector } from "react-redux";
import { RouteProp, StackActions, useNavigation, useRoute } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import GlobalModal, { createGlobalModal, globalModal } from "app/shared/components/modal/global-modal/global-modal";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { Constant } from "app/shared/constant/constant";
import FormPaymentCard from "app/modules/card-manager/payment-card/payment-card-create/form-payment-card/form-payment-card";
import { useDesktopMediaQuery } from "app/shared/util/media-query";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import { Block } from "app/shared/components/blocks/block";
import { spacing } from "app/shared/styles/spacing";
import { ACCOUNT } from "app/shared/services/services-model.type";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import SourceAccount from "app/shared/components/source-account/source-account";
import { fetchPaymentCardCreateRequest, setPaymentCardReset } from "../reducer/actions";
import StackParamsList from "app/navigation/nav-stack-params";
import { getPaymentCardStoreSelector } from "../reducer/selectors";
import { DataPaymentCardCreate } from "../reducer/types";
import { showModal } from "app/modules/modal-management/reducer/action";

type ProfileScreenRouteProp = RouteProp<StackParamsList, ScreenNameType.PAYMENT_CARD_CREATE>;

const PaymentCard = () => {
  const { colors } = useTheme();
  const dispatchStore = useDispatch();
  const { dispatch, navigate } = useNavigation();

  const isDesktop = useDesktopMediaQuery();
  const { t } = useTranslation();

  const [preScreen, setPreScreen] = useState<string>(t("CARD_DICH_VU_THE"));

  const onPressSubCancel = () => {
    if (routeProps?.params?.preScreen === ScreenNameType.LIST_PAYMENTS) dispatch(StackActions.replace(ScreenNameType.LIST_PAYMENTS));
    else dispatch(StackActions.replace(ScreenNameType.LIST_CARDS));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: preScreen,
      onPressSubtitle: () => onPressSubCancel(),
    },
    {
      name: t("CARD_THANH_TOAN_THE_TIN_DUNG"),
      onPressSubtitle: () => {},
    },
  ];

  const [globalModalRef] = useState<React.RefObject<any>>(createGlobalModal());
  const [accountDebit, setAccountDebit] = useState<ACCOUNT>({});
  const [isValidAccount, setIsValidAccount] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const routeProps = useRoute<ProfileScreenRouteProp>();
  const paymentCardStore = useSelector(getPaymentCardStoreSelector);

  const onCancel = () => {
    dispatchStore(
      showModal({
        modalType: "multiAction",
        modalProps: {
          open: true,
          message: t("COMMON_QUY_KHACH_MUON_HUY_GIAO_DICH"),
          acceptModal: () => onPressSubCancel(),
        },
      }),
    );
  };

  // Submit Khởi tạo
  const onSubmit = () => {
    setIsSubmit(true);
  };

  const onChangeAccountDebit = (account: ACCOUNT, isValid: boolean) => {
    setAccountDebit(account);
    setIsValidAccount(isValid);
  };

  const requestCreate = (data: DataPaymentCardCreate) => {
    if (accountDebit.ACCOUNTNO?.length && isValidAccount) {
      data.ACCOUNT_DEBIT = accountDebit;
      dispatchStore(fetchPaymentCardCreateRequest(data));
    }
  };

  const closeModal = () => {
    globalModal.hide(globalModalRef);
  };

  const actionShowModal = (content: JSX.Element) => {
    globalModal.show(content, globalModalRef);
  };

  useEffect(() => {
    if (routeProps?.params?.resetData === true) {
      dispatchStore(setPaymentCardReset());
    }
  }, [dispatchStore, routeProps?.params?.resetData]);

  useEffect(() => {
    if (routeProps?.params?.preScreen) {
      const value = routeProps?.params?.preScreen === ScreenNameType.LIST_PAYMENTS ? t("FUNC_DV_THANH_TOAN") : t("CARD_DICH_VU_THE");
      setPreScreen(value);
    }
  }, [routeProps?.params?.preScreen, t]);

  useEffect(() => {
    if (isSubmit) setIsSubmit(false);
  }, [isSubmit]);

  useEffect(() => {
    if (paymentCardStore.isCreated) {
      navigate(ScreenNameType.PAYMENT_CARD_CONFIRM, { preScreen: routeProps?.params?.preScreen });
    }
  }, [navigate, paymentCardStore.isCreated, routeProps?.params?.preScreen]);

  return (
    <Block flex={1} bg={colors.surface}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("CARD_THANH_TOAN_THE_TIN_DUNG")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? spacing.galactic : spacing.huge}>
          <StepProcessUniversal currentSteps={0} />
          <SourceAccount
            onChangeAccount={onChangeAccountDebit}
            type={[Constant.ACCOUNTTYPE.ACCOUNT_PAYMENT]}
            isSubmit={isSubmit}
            account={accountDebit}
          />
          <FormPaymentCard
            accountDebit={accountDebit}
            onSubmit={onSubmit}
            onCancel={onCancel}
            requestCreate={requestCreate}
            showModal={actionShowModal}
            closeModal={closeModal}
            cardParam={routeProps?.params?.card}
          />
        </Block>
        <GlobalModal ref={globalModalRef} />
      </ScrollView>
    </Block>
  );
};

export default PaymentCard;
